import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { LOCATION_GROUP_CONSTRAINTS } from './constraints.js';
export const locationGroupIdInputSchema = z.object({
    id: requiredUuidString(`${LOCATION_GROUP_CONSTRAINTS.id.label} id is required.`, `Invalid ${LOCATION_GROUP_CONSTRAINTS.id.label.toLowerCase()} id.`),
});
//# sourceMappingURL=id-input.js.map